"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyUser = identifyUser;
exports.initializeErrorReporting = initializeErrorReporting;
exports.reportError = reportError;
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _tracing = require("@sentry/tracing");
var _logrocket = _interopRequireDefault(require("logrocket"));
var _logrocketReact = _interopRequireDefault(require("logrocket-react"));
var _constants = require("../../constants");
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let deploymentStage = _constants.STAGE_DEVELOPMENT;
function canReportErrors() {
  if (process.env.REACT_APP_REPORT_ERRORS_DEBUG === 'true') {
    // eslint-disable-next-line no-console
    console.log("error-reporting: deploymentStage: ".concat(deploymentStage));
  }
  let reportErrors = process.env.REACT_APP_REPORT_ERRORS === 'true';
  if (isValidStage()) {
    reportErrors = process.env.REACT_APP_REPORT_ERRORS === undefined || process.env.REACT_APP_REPORT_ERRORS !== 'false';
  }
  return reportErrors;
}
function isValidStage() {
  return !(0, _index.isFedRAMP)() && (deploymentStage === _constants.STAGE_BETA || deploymentStage === _constants.STAGE_PRODUCTION);
}
function initializeErrorReporting(appId, dsn, appPrefix) {
  let requestSanitizer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  let responseSanitizer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  let sampleRate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1.0;
  let debug = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : process.env.REACT_APP_REPORT_ERRORS_DEBUG === 'true';
  let stage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : _constants.STAGE_DEVELOPMENT;
  deploymentStage = stage;
  if (canReportErrors()) {
    if (debug) {
      // eslint-disable-next-line no-console
      console.log("error-reporting: Sentry sample rate: ".concat(sampleRate));
    }
    Sentry.init({
      dsn,
      debug,
      integrations: [...Sentry.defaultIntegrations, new _tracing.Integrations.BrowserTracing({
        // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: sampleRate,
      release: "".concat(appPrefix, "@").concat(process.env.REACT_APP_BUILD_VERSION),
      environment: stage
    });
    _logrocket.default.init(appId, {
      release: process.env.REACT_APP_BUILD_VERSION,
      network: {
        requestSanitizer: request => _requestSanitizer(request, requestSanitizer),
        responseSanitizer: response => _responseSanitizer(response, responseSanitizer)
      }
    });
    (0, _logrocketReact.default)(_logrocket.default);
    _logrocket.default.getSessionURL(sessionURL => {
      Sentry.configureScope(scope => {
        scope.setExtra('sessionURL', sessionURL);
      });
    });
  }
}
function _requestSanitizer(request, requestSanitizer) {
  const USER_TOKEN = 'x-wasabi-user-token'; // Rack/NOC user token
  const AUTH_TOKEN = 'X-Wasabi-Authorization'; // IAM based auth token
  const REDACTED_VALUE = '** REDACTED **';

  // sanitize the auth header...
  if (request.headers[AUTH_TOKEN]) {
    request.headers[AUTH_TOKEN] = REDACTED_VALUE;
  } else if (request.headers[USER_TOKEN]) {
    request.headers[USER_TOKEN] = REDACTED_VALUE;
  }

  // sanitize the password while creating an account...
  if (request.body) {
    try {
      const requestBody = JSON.parse(request.body);
      if (requestBody.Password) {
        // if the request contains a Password, obscure if from view to/from LogRocket
        requestBody.Password = REDACTED_VALUE;

        // re-construct the request body...
        request.body = JSON.stringify(requestBody);
      }
      if (requestBody.password) {
        // if the request contains a password, obscure if from view to/from LogRocket
        requestBody.password = REDACTED_VALUE;

        // re-construct the request body...
        request.body = JSON.stringify(requestBody);
      }
    } catch (e) {
      // do nothing, request.body doesn't need to be formatted and should be passed as is
    }
  }
  return requestSanitizer ? requestSanitizer(request) : request;
}
function _responseSanitizer(response, responseSanitizer) {
  return responseSanitizer ? responseSanitizer(response) : response;
}
function reportError(error) {
  if (canReportErrors()) {
    _logrocket.default.captureException(error, {
      tags: {
        stage: process.env.NODE_ENV
      }
    });
    Sentry.captureException(error);
  }
}
function identifyUser(userProfile) {
  if (canReportErrors()) {
    _logrocket.default.identify(userProfile.Name, {
      name: "".concat(userProfile.FullName)
    });
    Sentry.setUser({
      username: userProfile.Name
    });
  }
}